import { catchError, map, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LocationDTO } from '../../../../dto/location/location.dto';
import { Location } from '../../../../models/location/Location.model';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';
import { DUNA_LOCATIONS_ADMIN_EVENT } from './locations-admin-events';

export function locations_suggested_admin(componentDataSourceService: ComponentDataSourceService) {
  return {
    name: 'Foreslåede lokationer (admin)',
    description: 'Foreslåede lokationer med oprettelse i administrationsvisning',
    execute: (params?: LoadDataParams) => {
      return componentDataSourceService.http
        .get<any>(`${environment.apiUrl}/locations/suggested`, params?.queryParams ? { params: params.queryParams } : {})
        .pipe(
          catchError((error) => {
            console.error('Error fetching suggested locations:', error);
            return of({ items: [], totalCount: 0 });
          }),
          map((result) => {
            if (result && Array.isArray(result.items)) {
              const locations = result.items.map((location: any) => {
                const locationDTO: LocationDTO = {
                  guid: location.guid,
                  locations_name: location.locations_name,
                  clean_name: location.clean_name,
                  data: location.data || {},
                  rooms: location.rooms || [],
                  users: location.users || [],
                  registered_percentage: location.registered_percentage || 0,
                  progress_percentage: location.progress_percentage || 0,
                  ok_percentage: location.ok_percentage || 0,
                  firefighter_count: location.firefighter_count || 0
                };
                return Location.fromDTO(locationDTO);
              });
              return {
                items: locations,
                totalCount: result.totalCount,
                pageSize: result.pageSize,
                pageIndex: result.pageIndex
              };
            }
            return { items: [], totalCount: 0, pageSize: 10, pageIndex: 0 };
          })
        );
    },
    settings: {
      columns: [
        { key: 'locations_name', header: 'Navn', type: 'text', sortable: true },
        { key: 'clean_name', header: 'Rolle navn', type: 'text', sortable: true },
        {
          key: 'actions',
          header: '',
          type: 'button',
          buttonText: 'Opret lokation',
          buttonColor: 'primary',
          variant: 'raised',
          action: (item: Location) => {
            window.dispatchEvent(
              new CustomEvent(DUNA_LOCATIONS_ADMIN_EVENT, {
                detail: { entity: 'suggested', action: 'open-create', row: item }
              })
            );
          }
        }
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      searchable: true,
      defaultSortColumn: 'locations_name',
      defaultSortDirection: 'asc'
    }
  };
}
